/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authcallbackemailmismatch3Inputs */

const en_authcallbackemailmismatch3 = /** @type {(inputs: Authcallbackemailmismatch3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You signed in with a different email than the one on the funnel. Try again with the email you used on claimpack.pt.`)
};

const pt_authcallbackemailmismatch3 = /** @type {(inputs: Authcallbackemailmismatch3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciou sessão com um email diferente do usado no funil. Tente com o email que usou em claimpack.pt.`)
};

/**
* | output |
* | --- |
* | "You signed in with a different email than the one on the funnel. Try again with the email you used on claimpack.pt." |
*
* @param {Authcallbackemailmismatch3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const authcallbackemailmismatch3 = /** @type {((inputs?: Authcallbackemailmismatch3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authcallbackemailmismatch3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_authcallbackemailmismatch3(inputs)
	return pt_authcallbackemailmismatch3(inputs)
});
export { authcallbackemailmismatch3 as "authCallbackEmailMismatch" }